export const BOOKING_URL = "https://seraphinacollective.janeapp.com/";
export const CHERRY_APPLY_URL =
  "https://pay.withcherry.com/elizabeth-taylor-?utm_source=merchant&utm_medium=website";
export const FACEBOOK_URL =
  "https://www.facebook.com/share/186sn51BB9/?mibextid=wwXIfr";

export const NAV_LINKS = [
  { label: "Home", to: "/" },
  { label: "Services", to: "/services" },
  { label: "About", to: "/about" },
  { label: "Before & After", to: "/before-after" },
  { label: "Reviews", to: "/reviews" },
  { label: "Peptides", to: "/peptides" },
  { label: "Financing", to: "/financing" },
  { label: "Contact", to: "/contact" },
];

export const CONTACT = {
  phone: "859-803-7176",
  phoneHref: "tel:+18598037176",
  fax: "859-838-9181",
  email: "info@seraphinacollective.net",
  address: "1169 Appomattox Dr, Florence, KY 41042",
  mapHref: "https://maps.google.com/?q=1169+Appomattox+Dr+Florence+KY+41042",
};
